import { atom } from "jotai";

export const DMPAtom = atom(null);
